// extracted by mini-css-extract-plugin
export default {"container":"vL-z","error":"wL-z","disabled":"xL-z","submit":"yL-z","option":"zL-z","success":"AL-z","failure":"BL-z"};